import React from 'react'
import { Link } from 'react-router-dom';
import '../../../App.css'
import './About.css'
import AboutLinks from '../AboutLinks';
import ScrollButton from '../../ScrollButton';
import ImageComponent from '../../ImageComponent';

function Leadership() {
  return (
    <div>
        <div className='hero-container leadership half'>
            <h1></h1>
         </div>
      <div className='leadership-about-links'><AboutLinks/></div>
      
      <div className='main'>
        <div className='leader-grid'>
        <h1>Leadership</h1>
        <h2>ELDERS</h2>
        <div className='grid-container'>
          <Link to={'/about/leadership/larry-loden'} className='link-to-bio'>
          <div className='grid-item'>
            <div className='tile'>
            <ImageComponent src={require('../../../img/larry_loden_sm_portrait_500px.jpg')} alt='larry loden portrait' />
            <h3>Larry Loden</h3>
            {/* <h4>Pastor-Teacher</h4> */}
            <Link to={'/about/leadership/larry-loden'} className='btn btn-primary'>Read Bio </Link>
            </div>
          </div>
          </Link>
          <Link to={'/about/leadership/dave-wolfe'} className='link-to-bio'>
          <div className='grid-item'>
          <div className='tile'>
            <ImageComponent src={require('../../../img/dave_wolfe_sm_portrait_500px.jpg')} alt='Dave Wolfe portrait' />
            <h3>Dave Wolfe</h3>
            {/* <h4>Pastor of Counseling and Discipleship</h4> */}
            <Link to={'/about/leadership/dave-wolfe'} className='btn btn-primary'>Read Bio</Link>
            </div>
          </div>
          </Link>
          <Link to={'/about/leadership/micah-monfrini'} className='link-to-bio'>
          <div className='grid-item'>
            <div className='tile'>
          
            <ImageComponent src={require('../../../img/micah_monfrini_sm_portrait_500px.jpg')} alt='Micah Monfrini portrait' />
            <h3>Micah Monfrini</h3>
            {/* <h4>Associate Pastor</h4> */}
            <Link to={'/about/leadership/micah-monfrini'} className='btn btn-primary'>Read Bio</Link>
            </div>
          </div>
          </Link>
          <Link to={'/about/leadership/dan-voss'} className='link-to-bio'>
          <div className='grid-item'>
            <div className='tile'>
          
            <ImageComponent src={require('../../../img/dan_voss_sm_portrait_500px.jpg')} alt='Micah Monfrini portrait' />
            <h3>Dan Voss</h3>
            {/* <h4>Elder</h4> */}
            <Link to={'/about/leadership/dan-voss'} className='btn btn-primary'>Read Bio</Link>
            </div>
          </div>
          </Link>
          
          
        </div>

        <br/><br/>

        <h2>PASTORAL STAFF</h2>
        <div className='grid-container'>
          <Link to={'/about/leadership/darrell-hayslip'} className='link-to-bio'>
          <div className='grid-item'>
            <div className='tile'>
          
            <img src={require('../../../img/darrell_hayslip_sm_portrait_500px.jpg')} alt='Darrell Hayslip portrait' loading='lazy' />
            <h3>Darrell Hayslip</h3>
            {/* <h4>Marriage & Family Counseling</h4> */}
            <Link to={'/about/leadership/darrell-hayslip'} className='btn btn-primary'>Read Bio</Link>
            </div>
          </div>
          </Link>
          <Link to={'/about/leadership/will-sanderson'} className='link-to-bio'>
          <div className='grid-item'>
          <div className='tile'>
            <img src={require('../../../img/will_sanderson_500px.jpg')} alt='Will Sanderson portrait' loading='lazy' />
            <h3>Will Sanderson</h3>
            {/* <h4>Student Ministry</h4> */}
            <Link to={'/about/leadership/will-sanderson'} className='btn btn-primary'>Read Bio</Link>
          </div>
          </div>
          </Link>

        </div>

        <br/><br/>

        <h2>DEACONS</h2>
        <div className='grid-container'>
          <div className='grid-item tile-d'>
            <img src={require('../../../img/ron_padula_sm_portrait2_500px.jpg')} alt='Ron Padula portrait' loading='lazy' />
            <h3>Ron Padula</h3>
            {/* <h4></h4> */}
          </div>
          <div className='grid-item tile-d'>
            <img src={require('../../../img/harrison_mosbey_sm_portrait_500px.jpg')} alt='Harrison Mosbey portrait' loading='lazy'/>
            <h3>Harrison Mosbey</h3>
            {/* <h4></h4> */}
          </div>
          <div className='grid-item tile-d'>
            <img src={require('../../../img/joel_goode_sm_portrait2_500px.jpg')} alt='Joel Goode portrait' loading='lazy'/>
            <h3>Joel Goode</h3>
            {/* <h4></h4> */}
          </div>
          <div className='grid-item tile-d'>
            <img src={require('../../../img/oscar_pan_sm_portrait_500px.jpg')} alt='Oscar Pan portrait' loading='lazy'/>
            <h3>Oscar Pan</h3>
            {/* <h4></h4> */}
          </div>
          <div className='grid-item tile-d'>
            <img src={require('../../../img/jason_sikes_sm_portrait_500px.jpg')} alt='Jason Sikes portrait' loading='lazy'/>
            <h3>Jason Sikes</h3>
            {/* <h4></h4> */}
          </div>
          <div className='grid-item tile-d'>
            <img src={require('../../../img/ramiro_avina_sm_portrait_500px.jpg')} alt='Ramiro Avina portrait' loading='lazy'/>
            <h3>Ramiro Aviña</h3>
            {/* <h4></h4> */}
          </div>
          <div className='grid-item tile-d'>
            <img src={require('../../../img/jesse_grant_sm_portrait_500px_2.jpg')} alt='Jesse Grant portrait' loading='lazy'/>
            <h3>Jesse Grant</h3>
            {/* <h4></h4> */}
          </div>
          <div className='grid-item tile-d'>
            <img src={require('../../../img/luke_piland_sm_portrait_500px.jpg')} alt='Luke Piland portrait' loading='lazy'/>
            <h3>Luke Piland</h3>
            {/* <h4></h4> */}
          </div>
          
        </div>
        <br/><br/>

        <h2>ADMINISTRATIVE STAFF</h2>
        <div className='grid-container'>
          <div className='grid-item tile-d'>
            <img src={require('../../../img/paul_damato_sm_portrait_500px.jpg')} alt='Paul DAmato portrait' loading='lazy'/>
            <h3>Paul D'Amato</h3>
            {/* <h4></h4> */}
          </div>
          </div>
        </div>
      </div>
      <ScrollButton/>
    </div>


  )
}

export default Leadership